import React, { useState, useEffect, useContext, useMemo, useRef, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import HamburgerMenu from '../../Components/HamburgerMenu/HamburgerMenu.jsx';
import ReactDatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { registerLocale, setDefaultLocale } from "react-datepicker";
import enGB from 'date-fns/locale/en-GB';
import { useTranslation } from 'react-i18next';
import UserService from '../../Services/user.service.js';
import './ProfitAndLossReport.css';
import backIcon from '../../assests/images/left-arrow.png';
import EnumsService from '../../Services/enums.service.js';
import loadingAnimation from "../../assests/images/Animation.gif";
import { ToastContainer, toast } from "react-toastify";
import Header from '../../Components/Header/Header.js';
import { TreeTable } from 'primereact/treetable';
import { Column } from 'primereact/column';
import { ColumnGroup } from 'primereact/columngroup';
import { Row } from 'primereact/row';
import { InputText } from 'primereact/inputtext';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { Button } from 'primereact/button';
import ClientService from '../../Services/client.service.js';
import ProfitAndLossService from '../../Services/profitAndLoss.service.js';
import ProjectsService from '../../Services/projects.service.js';
import PuffLoader from "react-spinners/PuffLoader";
import { NavHistoryContext } from '../../Contexts/NavHistoryContext.js';
//mui table import
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import {
    Box,
    Modal,
    Typography,
    colors,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    ListItem,
    TextField,
    Autocomplete,
    Popper,
    Checkbox,
    ToggleButton,
    ToggleButtonGroup,
    Button as MuiButton,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import DownloadIcon from '@mui/icons-material/Download';
import ProfitAndLossReportTable from '../../Components/ProfitAndLossReport/SubComponents/ProfitAndLossReportTable.jsx';
import ProfitAndLossDownloadModal from '../../Components/ProfitAndLossReport/ProfitAndLossDownloadModal.jsx';
import SignatureModal from '../../Components/Widgets/SignatureModal/SignatureModal';
import Swal from 'sweetalert2';
import { selectedMonthsToDateBounds, buildSelectedMonthsFromDateRange } from '../../Utils/ReportUtils.js';
import {
    mergeReportPdfWithSignature,
    triggerBlobDownload,
} from '../../Utils/profitAndLossSignaturePdf.js';
import ReportsService from '../../Services/reports.service.js';

import CircularProgress, {
    circularProgressClasses,
} from '@mui/material/CircularProgress';
import { beautifyNumber } from '../../Utils/FormatNumber.js';
import DateInput from '../../Components/DateInput/DateInput.js';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';
import DescriptionIcon from '@mui/icons-material/Description';
import FilterMonthYearPicker from '../../Components/Widgets/CustomDates/FilterMonthYearPicker/FilterMonthYearPicker.jsx';
import headerStyles from '../../Components/ClientDetails/SubComponents/ClientDetailsHeader/HeaderToolbar.module.scss';
import dayjs, { Dayjs } from 'dayjs';
import utc from 'dayjs/plugin/utc';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import UpperPanelDetails from '../../Components/Widgets/UpperPanelDetails/UpperPanelDetails.jsx';
import { useHamburgerMenu } from '../../Contexts/HamburgerMenuContext.js';
import NavigationButton from '../../Components/NavigationButton/NavigationButton.jsx';
import CustomBreadcrumbs from '../../Components/CustomBreadcrumbs/CustomBreadcrumbs.jsx'
import { setRange } from '../../store/reducers/reportPeriodSlice';
import { useClientNavigation } from '../../hooks/useClientNavigation.js';
import DepreciationJournalEntriesModal from '../../Components/Widgets/DepreciationJournalEntriesModal/DepreciationJournalEntriesModal.jsx';
import ProfitAndLossHtmlPreview from '../../Components/Widgets/ProfitAndLossHtmlPreview/ProfitAndLossHtmlPreview.jsx';
import EditableProfitAndLossHtmlPreview from '../../Components/Widgets/EditableProfitAndLossHtmlPreview/EditableProfitAndLossHtmlPreview.jsx';
import { EDITABLE_SOURCE_PL_REPORT } from '../../Components/Widgets/EditableProfitAndLossHtmlPreview/editableProfitAndLossUtils.js';
import '../Document/Document.scss';
import documentGridStyles from '../../Components/Document/SubComponents/DocumentDataGrid.module.scss';

dayjs.extend(utc);
registerLocale('en-GB', {
    ...enGB,
    localize: {
        ...enGB.localize,
        month: n => n + 1, // Display months as numbers starting from 1
    },
    formatLong: {
        ...enGB.formatLong,
        date: () => 'MM/yyyy', // Date format when the picker is not showing
    },
});

setDefaultLocale('en-GB'); // Set the default locale to use it

// Helper function to adjust date to Israel time zone (UTC+2)
const adjustToIsraelTime = (date) => {
    const israelTimeOffset = 2 * 3600 * 1000; // 2 hours in milliseconds
    return new Date(date.getTime() + israelTimeOffset);
};

// Helper function to get the start of the year in Israel time
const getStartOfYear = (date) => {
    const startOfYear = new Date(date.getFullYear(), 0, 1); // Jan 1st of the given year
    return adjustToIsraelTime(startOfYear);
};

// Helper function to get the current month in Israel time
const getCurrentMonth = (date) => {
    const currentMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0); // Last day of the current month
    return adjustToIsraelTime(currentMonth);
};


/**
 * Builds the string key used for each month column (“MM/YYYY”).
 */
const monthToField = (jsDate) =>
    `${String(jsDate.getMonth() + 1).padStart(2, '0')}/${jsDate.getFullYear()}`;

/**
 * Converts a year number (2024) to the range string
 * expected by your old template (“2024-01-01 - 2024-12-31”).
 */
const yearToRangeField = (yr) => `${yr}-01-01 - ${yr}-12-31`;

const compareProjectCodes = (a, b) =>
    String(a?.code ?? '').localeCompare(String(b?.code ?? ''), undefined, { numeric: true });

/**
 * Section the server emits for sort codes that participate in P&L but were never mapped
 * to a sort-code group. Must stay in sync with
 * ProfitAndLossReportService.NoSortCodeGroupSection on the server.
 */
const NO_SORT_CODE_GROUP_SECTION = 'ללא קבוצה מיון';

const StyledProjectsPopper = styled(Popper)({
    '& .MuiPaper-root': {
        borderRadius: '8px',
        background: '#ffffff',
        border: '1px solid #e5e7eb',
        boxShadow: '0 12px 28px rgba(20, 30, 43, 0.16)',
        overflow: 'hidden',
    },
    '& .MuiAutocomplete-listbox': {
        padding: 0,
        textAlign: 'start',
    },
    '& .MuiAutocomplete-option': {
        justifyContent: 'flex-start',
        textAlign: 'start',
        fontSize: 'var(--xtram-text-sm, 13px)',
        fontWeight: 500,
        minHeight: 'var(--xtram-menu-item-height, 36px)',
        '&[aria-selected="true"]': {
            background: 'rgba(48, 79, 255, 0.1) !important',
            color: '#304fff',
            fontWeight: 700,
        },
        '&.Mui-focused, &:hover': {
            background: '#304fff !important',
            color: '#ffffff',
        },
    },
});

function ProfitAndLossReport() {
    const navigate = useNavigate();
    const { i18n, t } = useTranslation();
    const direction = i18n.dir();
    const [user, setUser] = useState(null);
    const [token, setToken] = useState('');
    // const [data, setData] = useState([]);
    const [client, setClient] = useState(null);
    const [type, setType] = useState('');
    const location = useLocation();
    const [loading, setLoading] = useState(false);
    const [downloadModalOpen, setDownloadModalOpen] = useState(false);
    const [showSignatureModal, setShowSignatureModal] = useState(false);
    const [pendingDownloadOptions, setPendingDownloadOptions] = useState(null);
    const { goBack } = useContext(NavHistoryContext);

    // before redux
    // Initialize the dates from localStorage or use defaults
    // const [startDate, setStartDate] = useState(null);

    // const [endDate, setEndDate] = useState(null);

    // const [startYearDate, setStartYearDate] = useState(null);

    // const [endYearDate, setEndYearDate] = useState(null);

    // Add any other state like isMonthly
    // const [isMonthly, setIsMonthly] = useState(true); // Default is true
    const dispatch = useDispatch();

    const {
        isMonthly,
        startDate,
        endDate,
        startYearDate,
        endYearDate,
    } = useSelector((state) => state.reportPeriodSlice);


    const { viewSortCodeReport } = useClientNavigation(client);
    const [sortCodesOptions, setSortCodesOptions] = useState([]);
    const [sortCodesGroupOptions, setSortCodesGroupOptions] = useState([]);
    const [columns, setColumns] = useState([]);
    const [totalColumns, setTotalColumns] = useState(0);
    const [isDataFetched, setIsDataFetched] = useState(false);
    const [nodes, setNodes] = useState([]);
    const [footerTotals, setFooterTotals] = useState({});
    const [specialNode, setSpecialNode] = useState(null);
    const [expandedRows, setExpandedRows] = useState({});
    const [isExpandedToggle, setIsExpandedToggle] = useState(false);

    //mui searches:
    const [focused, setFocused] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    
    // Non-participant items flag
    const [showNonParticipantItems, setShowNonParticipantItems] = useState(() => {
        const stored = localStorage.getItem('showNonParticipantItems');
        return stored === 'true';
    });

    // Unprocessed documents flag. When ON we include unprocessed documents (onlyProcessed = false);
    // when OFF we exclude them (onlyProcessed = true). Default OFF → only processed documents.
    const [showUnprocessed, setShowUnprocessed] = useState(() => {
        const stored = localStorage.getItem('profitAndLossShowUnprocessed');
        return stored === 'true';
    });

    // Date basis for aggregation. true → bucket documents by their document date,
    // false → bucket by registration month. Default true (document date).
    const [filterByDocumentDate, setFilterByDocumentDate] = useState(() => {
        const stored = localStorage.getItem('profitAndLossFilterByDocumentDate');
        return stored === null ? false : stored === 'true';
    });

    // When ON, sort codes that participate in P&L but have no sort-code group are listed in
    // their own "ללא קבוצה מיון" section instead of being folded into general expenses.
    const [showItemsWithoutSortCodeGroup, setShowItemsWithoutSortCodeGroup] = useState(() => {
        const stored = localStorage.getItem('profitAndLossShowItemsWithoutSortCodeGroup');
        return stored === 'true';
    });

    // Right-click flow for editing a sort code's P&L mapping (group + participation).
    const [assignGroupSortCode, setAssignGroupSortCode] = useState(null);
    const [assignGroupValue, setAssignGroupValue] = useState(null);
    const [assignParticipates, setAssignParticipates] = useState(true);

    const [byProjectsFilterActive, setByProjectsFilterActive] = useState(false);
    const [segmentationProjects, setSegmentationProjects] = useState([]);
    const [loadingSegmentations, setLoadingSegmentations] = useState(false);
    const [selectedFromSegmentation, setSelectedFromSegmentation] = useState(null);
    const [selectedToSegmentation, setSelectedToSegmentation] = useState(null);
    const [isJournalEntrySelectionModalOpen, setIsJournalEntrySelectionModalOpen] = useState(false);
    const [isHtmlPreviewModalOpen, setIsHtmlPreviewModalOpen] = useState(false);
    const [htmlPreviewContent, setHtmlPreviewContent] = useState('');
    const [openEditableProfitAndLossModal, setOpenEditableProfitAndLossModal] = useState(false);
    const [editableProfitAndLossHtmlContent, setEditableProfitAndLossHtmlContent] = useState('');
    const [editableShowPercentageColumn, setEditableShowPercentageColumn] = useState(false);
    const editableInitialLoadDoneRef = useRef(false);

    const { setMenuProps, refreshEnumsCallback } = useHamburgerMenu();
    useEffect(() => {
        setMenuProps({ client });
    }, [client, setMenuProps]);

    const fetchEnums = async (token, user) => {
        setLoading(true);
        try {
            const sortCodeGroupResponse = await EnumsService.GetSortCodesGroupByAccountantId(user.accountantId, token);
            const sortCodeGroupData = await sortCodeGroupResponse.json();
            setSortCodesGroupOptions(sortCodeGroupData)

            const sortCodeResponse = await EnumsService.GetSortCodesByAccountantId(user.accountantId, token);
            if (sortCodeResponse.ok) {
                setSortCodesOptions(await sortCodeResponse.json());
            }

            setIsDataFetched(true);
            // toast.success(t("Data has been fetched"));
        } catch (error) {
            console.error("Error fetching enum data:", error);
            toast.error(`${t("Error fetching enum data")}: ${error}`);
        }
        setLoading(false);
    };

    const cleanState = (st) => {
        if (!st) return null;
        const { previousLocation, ...rest } = st;
        return rest;
    };
    
    // sortCodeId comes from the report row so SortCodeReport opens the exact sort code
    // even when several sort codes share the same name.
    const handleSelect = (sortCodeName, isSpecial = false, sortCodeId = null) => {
        if (!sortCodeName) return;            // guard

        const dateState = {
            startDate,
            endDate,
            isMonthly,
            startYearDate,
            endYearDate,
        };

        /* ─── 1) “general expenses” bucket ───────────────────────── */
        const segmentationFilter = buildSegmentationFilter();

        if (isSpecial) {
            navigate('/SortCodeReport', {
                state: {
                    type,
                    client,
                    groupName: '',
                    sortCodeName,
                    sortCodeId,
                    breadcrumbs: ['Reports', 'ProfitAndLossReport'],
                    previousLocation: {
                        pathname: location.pathname,
                        state: cleanState(location.state),
                    },
                    ...dateState,
                    segmentationFilter,
                    isByProjects: !!segmentationFilter,
                }
            })

            return;
        }

        /* ─── 2) find the parent group that owns this sort‑code ──── */
        const parent = nodes.find((n) =>
            (n.children ?? []).some((ch) => ch.data.Description === sortCodeName),
        );

        if (!parent) return;                 // should not happen, but be safe

       

        navigate('/SortCodeReport', {
            state: {
                type,
                client,
                groupName: parent.data.Description,
                sortCodeName,
                sortCodeId,
                breadcrumbs: ['Reports', 'ProfitAndLossReport'],
                previousLocation: {
                    pathname: location.pathname,
                    state: cleanState(location.state),
                },
                ...dateState,
                segmentationFilter,
                isByProjects: !!segmentationFilter,
            }
        });
    };


    const handleRangeChange = async (monthly) => {
        if (monthly === isMonthly) return;

        const utcYear = (date, fallback = new Date().getUTCFullYear()) =>
            date instanceof Date && !Number.isNaN(date.getTime()) ? date.getUTCFullYear() : fallback;

        if (!monthly) {
            // Monthly → Yearly: carry over years from the monthly range
            const from = Math.min(utcYear(startDate), utcYear(endDate, utcYear(startDate)));
            const to = Math.max(utcYear(startDate), utcYear(endDate, utcYear(startDate)));
            dispatch(
                setRange({
                    isMonthly: false,
                    startYearDate: new Date(Date.UTC(from, 0, 1, 0, 0, 0, 0)),
                    endYearDate: new Date(Date.UTC(to, 11, 31, 23, 59, 59, 0)),
                })
            );
            return;
        }

        // Yearly → Monthly: carry over years from the yearly pickers (Jan → Dec)
        const from = Math.min(utcYear(startYearDate), utcYear(endYearDate, utcYear(startYearDate)));
        const to = Math.max(utcYear(startYearDate), utcYear(endYearDate, utcYear(startYearDate)));
        dispatch(
            setRange({
                isMonthly: true,
                startDate: new Date(Date.UTC(from, 0, 1, 0, 0, 0, 0)),
                endDate: new Date(Date.UTC(to, 11, 31, 23, 59, 59, 0)),
            })
        );
    };
    // Prefix for localStorage keys
    const prefix = 'profitAndLoss';

    // Utility function to load from localStorage and convert to Date if necessary
    const loadDateFromLocalStorage = (key, fallbackDate) => {
        const storedDateString = localStorage.getItem(key);
        return storedDateString ? new Date(storedDateString) : fallbackDate;
    };


    // Utility function to save to localStorage
    const saveToLocalStorage = (key, value) => {
        localStorage.setItem(key, value);
    };
    const handleEndDateChange = async (date) => {
        const newDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), 10));

        // Persist the new end date to localStorage
        localStorage.setItem('EndDate', newDate);

        if (isMonthly) {
            setColumns(generateMonthColumns(startDate, newDate));
            // await fetchProfitAndLossDetails(new Date(startDate), newDate);
        }

        // setEndDate(newDate);
    };

    const handleStartDateChange = async (date) => {
        const newDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), 10));

        // Persist the new start date to localStorage
        localStorage.setItem('StartDate', newDate);

        if (isMonthly) {
            setColumns(generateMonthColumns(newDate, endDate));
            // await fetchProfitAndLossDetails(newDate, new Date(endDate));
        }

    };

    const handleStartDateChangeNew = async (newValue, type) => {

        const newDate = new Date(newValue);
        let updatedDate;
        if (type === 'year') {
            updatedDate = new Date(Date.UTC(newDate.getFullYear(), startDate.getMonth(), 10));
        } else if (type === 'month') {
            updatedDate = new Date(Date.UTC(startDate.getFullYear(), newDate.getMonth(), 10));
        }

        if (isMonthly) {
            setColumns(generateMonthColumns(updatedDate, endDate));
            // await fetchProfitAndLossDetails(newDate, new Date(endDate));
        }

        localStorage.setItem(('StartDate'), updatedDate);
        dispatch(setRange({ startDate: updatedDate }));
        // setStartDate(updatedDate);
    };

    const handleEndDateChangeNew = async (newValue, type) => {
        const newDate = new Date(newValue);
        let updatedDate;

        if (type === 'year') {
            updatedDate = new Date(Date.UTC(newDate.getFullYear(), endDate.getMonth(), 10));
        } else if (type === 'month') {
            updatedDate = new Date(Date.UTC(endDate.getFullYear(), newDate.getMonth(), 10));
        }

        if (isMonthly) {
            setColumns(generateMonthColumns(startDate, updatedDate));
            // await fetchProfitAndLossDetails(newDate, new Date(endDate));
        }

        localStorage.setItem(('EndDate'), updatedDate);
        dispatch(setRange({ endDate: updatedDate }));
        // setEndDate(updatedDate);

    };

    const handleStartYearDate = async (date) => {
        // const newDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), 10));

        // Persist the new start year date to localStorage
        localStorage.setItem('StartYearDate', date);

        dispatch(setRange({ startYearDate: date }));
        // setStartYearDate(newDate);
    };

    const handleEndYearDate = async (date) => {
        // const newDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), 10));

        // Persist the new end year date to localStorage
        localStorage.setItem('EndYearDate', date);
        dispatch(setRange({ endYearDate: date }));
        // setEndYearDate(newDate);
    };




    /**
 * Fetches profit‑and‑loss details and prepares:
 *   • Table columns           (setColumns)
 *   • Row tree nodes          (setNodes + setSpecialNode)
 *   • Footer aggregate row    (setFooterTotals)
 *   • Loading spinner state   (setLoading)
 *
 * The function works for both “monthly” and “yearly” modes.
 */
    /**
    * Fetches profit‑and‑loss details and prepares:
    *   • column definitions
    *   • row tree structure (nodes + specialNode)
    *   • footer aggregate
    *   • loading state
    *
    * Works for both monthly and yearly views.
    */
    const buildSegmentationFilter = useCallback(() => {
        if (!byProjectsFilterActive) return null;
        const filter = { profitAndLossType: 'Projects' };
        if (selectedFromSegmentation?.id) {
            filter.fromSegmentationId = selectedFromSegmentation.id;
        }
        if (selectedToSegmentation?.id) {
            filter.toSegmentationId = selectedToSegmentation.id;
        }
        return filter;
    }, [byProjectsFilterActive, selectedFromSegmentation, selectedToSegmentation]);

    const loadSegmentationProjects = useCallback(async () => {
        if (!client?.caseId || !token) return;
        setLoadingSegmentations(true);
        try {
            const res = await ProjectsService.getProjects(client.caseId, token);
            if (!res.ok) {
                toast.error(t('ErrorRetrievingProjects'));
                return;
            }
            const raw = await res.json();
            const list = Array.isArray(raw) ? raw : [];
            const mapped = list
                .map((p) => ({
                    id: String(p.projectId ?? p.id ?? ''),
                    code: p.code ?? '',
                    name: p.name ?? '',
                    label: `${p.code ?? ''} — ${p.name ?? ''}`,
                }))
                .filter((p) => p.id)
                .sort((a, b) => compareProjectCodes(a, b));
            setSegmentationProjects(mapped);
        } catch (e) {
            console.error(e);
            toast.error(t('ErrorRetrievingProjects'));
        } finally {
            setLoadingSegmentations(false);
        }
    }, [client?.caseId, token, t]);

    const handleByProjectsFilterToggle = async (active) => {
        if (!active) {
            setByProjectsFilterActive(false);
            setSelectedFromSegmentation(null);
            setSelectedToSegmentation(null);
            if (client && token) {
                const start = isMonthly ? startDate : startYearDate;
                const end = isMonthly ? endDate : endYearDate;
                if (start && end) {
                    await fetchProfitAndLossDetails(start, end, null);
                }
            }
            return;
        }
        setByProjectsFilterActive(true);
        setSelectedFromSegmentation(null);
        setSelectedToSegmentation(null);
        await loadSegmentationProjects();
        if (client && token) {
            const start = isMonthly ? startDate : startYearDate;
            const end = isMonthly ? endDate : endYearDate;
            if (start && end) {
                await fetchProfitAndLossDetails(start, end, { profitAndLossType: 'Projects' });
            }
        }
    };

    const handleFromSegmentationChange = async (_, newVal) => {
        if (!byProjectsFilterActive) return;
        let from = newVal;
        let to = selectedToSegmentation;
        if (from && to && compareProjectCodes(from, to) > 0) {
            toast.info(t('ProjectRangeAdjustedToCodeOrder'));
            const tmp = from;
            from = to;
            to = tmp;
            setSelectedToSegmentation(to);
        }
        setSelectedFromSegmentation(from);
        const start = isMonthly ? startDate : startYearDate;
        const end = isMonthly ? endDate : endYearDate;
        if (start && end) {
            await fetchProfitAndLossDetails(start, end, {
                profitAndLossType: 'Projects',
                ...(from?.id ? { fromSegmentationId: from.id } : {}),
                ...(to?.id ? { toSegmentationId: to.id } : {}),
            });
        }
    };

    const handleToSegmentationChange = async (_, newVal) => {
        if (!byProjectsFilterActive) return;
        let to = newVal;
        let from = selectedFromSegmentation;
        if (from && to && compareProjectCodes(from, to) > 0) {
            toast.info(t('ProjectRangeAdjustedToCodeOrder'));
            const tmp = to;
            to = from;
            from = tmp;
            setSelectedFromSegmentation(from);
        }
        setSelectedToSegmentation(to);
        const start = isMonthly ? startDate : startYearDate;
        const end = isMonthly ? endDate : endYearDate;
        if (start && end) {
            await fetchProfitAndLossDetails(start, end, {
                profitAndLossType: 'Projects',
                ...(from?.id ? { fromSegmentationId: from.id } : {}),
                ...(to?.id ? { toSegmentationId: to.id } : {}),
            });
        }
    };

    async function fetchProfitAndLossDetails(startDate, endDate, segmentationFilterOverride) {
        setLoading(true);
        try {
            const segmentationFilter =
                segmentationFilterOverride !== undefined
                    ? segmentationFilterOverride
                    : buildSegmentationFilter();

            // Year picker stores end-of-year UTC; normalize to full-year bounds for the API.
            const yearlyStartDate = dayjs.utc(startDate).startOf('year').toDate();
            const yearlyEndDate = dayjs.utc(endDate).endOf('year').toDate();

            const onlyProcessed = !showUnprocessed;

            /* ─── 1 · API ─── */
            const resp = isMonthly
                ? await ProfitAndLossService.ProfitAndLossDetails(
                    client.caseId,
                    client.accountantId,
                    startDate,
                    endDate,
                    token,
                    showNonParticipantItems,
                    segmentationFilter,
                    filterByDocumentDate,
                    onlyProcessed,
                    showItemsWithoutSortCodeGroup,
                )
                : await ProfitAndLossService.ProfitAndLossDetailsYearly(
                    client.caseId,
                    client.accountantId,
                    yearlyStartDate,
                    yearlyEndDate,
                    token,
                    showNonParticipantItems,
                    segmentationFilter,
                    filterByDocumentDate,
                    onlyProcessed,
                    showItemsWithoutSortCodeGroup,
                );

            if (!resp.ok) {
                toast.error(
                    `${t('ErrorFetchingProfitLossDetails')}: ${await resp.text()}`,
                );
                return;
            }

            const dto = await resp.json(); // array of groups

            /* ─── 2 · columns ─── */
            let columns;
            if (isMonthly) {
                columns = generateMonthColumns(startDate, endDate);
            } else {
                const years = new Set(
                    dto.flatMap((g) => g.rows.flatMap((r) => r.years.map((y) => y.year))),
                );
                columns = [...years]
                    .sort((a, b) => a - b)
                    .map((yr) => ({
                        field: yearToRangeField(yr),
                        header: yearToRangeField(yr),
                    }));
            }
            setColumns(columns);

            /* ─── 3 · footer skeleton ─── */
            const footerTotals = Object.fromEntries(columns.map((c) => [c.field, 0]));
            footerTotals.total = 0;

            /* ─── 4 · nodes ─── */
            const newNodes = [];
            let specialNode = null;

            dto.forEach((group, gIdx) => {
                const cat = group.groupName ?? '';
                const isProfitCategory = sortCodesGroupOptions.some(
                    (opt) => opt.sortCodeGroupProfitName === cat,
                );

                const children = [];
                const categoryTotals = { total: 0 };
                const rowsArr = isMonthly ? group.sortCodes : group.rows;

                let subtotalRow = null;

                rowsArr.forEach((row, rIdx) => {
                    const rowName = row.sortCodeName;
                    const isServerSubtotal = row.sortCodeId === 'SUBTOTAL';
                    const ignoreAsVisible =
                        rowName.includes('רווח') && cat !== ''; // hide profit row except general bucket

                    const rowData = {};
                    let rowSum = 0;

                    if (isMonthly) {
                        columns.forEach(({ field }) => {
                            const m = row.months.find(
                                (x) => monthToField(new Date(x.month)) === field,
                            );
                            const v = m ? m.amount : 0;
                            rowData[field] = v;
                            rowSum += v;
                            if (!ignoreAsVisible && !isServerSubtotal) {
                                footerTotals[field] += v;
                                footerTotals.total += v;
                            }
                        });
                    } else {
                        columns.forEach(({ field }) => {
                            const yr = parseInt(field.slice(0, 4), 10);
                            const y = row.years.find((x) => x.year === yr);
                            const v = y ? y.amount : 0;
                            rowData[field] = v;
                            rowSum += v;
                            if (!ignoreAsVisible && !isServerSubtotal) {
                                footerTotals[field] += v;
                                footerTotals.total += v;
                            }
                        });
                    }
                    rowData.total = rowSum;

                    /* aggregate to category total - only for non-subtotal rows */
                    if (!isServerSubtotal) {
                        columns.forEach(({ field }) => {
                            categoryTotals[field] =
                                (categoryTotals[field] || 0) + rowData[field];
                        });
                        categoryTotals.total =
                            (categoryTotals.total || 0) + rowSum;
                    }

                    /* keep server subtotal for later */
                    if (isServerSubtotal) {
                        subtotalRow = {
                            key: `${cat}-Σ`,
                            isSubtotal: true,
                            data: { Description: rowName, ...rowData },
                        };
                    } else if (!ignoreAsVisible || cat === '') {
                        children.push({
                            key: `${cat}-${rIdx}`,
                            data: {
                                Description: rowName,
                                SortCodeId: row.sortCodeId,
                                ...rowData,
                            },
                        });
                    }
                });

                /* parent node */
                if (subtotalRow) children.push(subtotalRow);

                const parent = {
                    key: `${gIdx}`,
                    data: {
                        Description: cat || t('GeneralExpenses'),
                        // Rows here are unmapped sort codes, so the table lets the user
                        // right-click one and assign it a sort-code group.
                        isWithoutSortCodeGroup: cat === NO_SORT_CODE_GROUP_SECTION,
                        ...categoryTotals,
                    },
                    // expand only if there is at least one non‑subtotal child
                    children: children.length ? children : undefined,
                };

                if (cat === '') specialNode = parent;
                else if (cat !== 'Years') newNodes.push(parent);
            });

            /* ─── 5 · commit state ─── */
            setNodes(newNodes);
            setSpecialNode(specialNode);
            setFooterTotals(footerTotals);
        } catch (err) {
            toast.error(`${t('ErrorFetchingProfitLossDetails')}: ${err.message}`);
        } finally {
            setLoading(false);
        }
    }





    useEffect(() => {
        const fetchUserData = async () => {
            setLoading(true);
            try {
                const currentUser = await UserService.getCurrentUser();
                const currentToken = await UserService.getCurrentToken();
                if (currentUser && currentToken) {
                    setUser(currentUser);
                    setToken(currentToken);

                    if (location.state && location.state.client && location.state.type) {
                        setType(location.state.type)
                        setClient(location.state.client);
                        await fetchEnums(currentToken, currentUser);
                    }
                    // Fetch financial data for the current date on initial load only
                }
                else {
                    navigate("/login");
                }

            } catch (error) {
                // Handle error - maybe navigate to login or show a message
            }
            setLoading(false);
        };


        fetchUserData();

    }, []);

    const loadFlag = () => localStorage.getItem('isMonthly') === 'true';
    const storeFlag = (flag) => localStorage.setItem(('isMonthly'), flag);

    useEffect(() => {
        dispatch(setRange({ isMonthly: loadFlag() }));   // באתחול
    }, []);

    useEffect(() => {                                  // בכל שינוי
        storeFlag(isMonthly);
    }, [isMonthly]);

    /* ---------- helpers ---------- */
    // const makeKey = (k) => `profitAndLoss-${k}`;
    /* ---------- useEffect that restores the picker ---------- */
    /* ---------- restore picker ---------- */
    useEffect(() => {
        if (!isDataFetched) return;

        /* --- שלב 1: קריאת ערכים מה-localStorage או ברירת-מחדל --- */
        const storedStartDateStr = localStorage.getItem('StartDate');
        const storedEndDateStr = localStorage.getItem('EndDate');
        const storedStartYearDateStr = localStorage.getItem('StartYearDate');
        const storedEndYearDateStr = localStorage.getItem('EndYearDate');

        const startDate = storedStartDateStr ? new Date(storedStartDateStr) : getStartOfYear(new Date());
        const endDate = storedEndDateStr ? new Date(storedEndDateStr) : getCurrentMonth(new Date());
        const startYearDate = storedStartYearDateStr ? new Date(storedStartYearDateStr) : new Date(Date.UTC(startDate.getFullYear(), 0, 1));
        const endYearDate = storedEndYearDateStr ? new Date(storedEndYearDateStr) : new Date(Date.UTC(endDate.getFullYear(), 11, 31));

        /* --- שלב 2: שמירה חזרה ל-localStorage אם טרם נשמר --- */
        if (!storedStartDateStr) localStorage.setItem('StartDate', startDate.toISOString());
        if (!storedEndDateStr) localStorage.setItem('EndDate', endDate.toISOString());
        if (!storedStartYearDateStr) localStorage.setItem('StartYearDate', startYearDate.toISOString());
        if (!storedEndYearDateStr) localStorage.setItem('EndYearDate', endYearDate.toISOString());

        /* --- שלב 3: עדכון Redux --- */
        dispatch(
            setRange({
                startDate,
                endDate,
                startYearDate,
                endYearDate,
                isMonthly: loadFlag(), // חדש
            })
        );

        /* --- שלב 4: בניית עמודות לטבלה/גרף --- */
        setColumns(generateMonthColumns(startDate, endDate));


    }, [isDataFetched, dispatch, token, client]);



    // Single fetch path for mode + date range changes (avoids double calls when
    // handleRangeChange updates isMonthly and dates in the same setRange).
    useEffect(() => {
        if (!client || !token) return;

        if (isMonthly && startDate && endDate) {
            fetchProfitAndLossDetails(startDate, endDate);
        } else if (!isMonthly && startYearDate && endYearDate) {
            fetchProfitAndLossDetails(startYearDate, endYearDate);
        }
    }, [
        isMonthly,
        startDate,
        endDate,
        startYearDate,
        endYearDate,
        showNonParticipantItems,
        showUnprocessed,
        filterByDocumentDate,
        showItemsWithoutSortCodeGroup,
    ]);



    const footerTemplate = (col) => {
        // Retrieve the value from footerTotals
        const column = col.field ?? col;
        const value = footerTotals[column] ?? 0;

        // Determine the color based on the value: green if positive, red if negative
        let color = value > 0 ? 'green' : 'red';

        // Format the number and return a styled span
        return (
            <span style={{ color: color, fontWeight: 'bold' }}>
                {(value !== null ? parseFloat(value).toFixed(2) : '0.00').toLocaleString()}₪
            </span>
        );

    };

    const footerTemplate1 = (childData) => {
        // Retrieve the value from footerTotals
        const value = childData ?? 0;

        // Determine the color based on the value: green if positive, red if negative
        let color = value > 0 ? 'green' : 'red';

        // Format the number and return a styled span
        return (
            <span style={{ color: color, fontWeight: 'bold' }}>
                {(value !== null ? parseFloat(value).toFixed(2) : '0.00').toLocaleString()}₪
            </span>
        );

    };


    const FooterToggleTemplate2 = () => {
        return (
            <div className='footerToggle' style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
                <Button style={{ width: '20px', height: '20px', color: '#6b7280' }} type="button"
                    icon={isExpandedToggle ? "pi pi-chevron-down" : "pi pi-chevron-right"}
                    onClick={() => {
                        setIsExpandedToggle(prev => !prev);
                    }} text />
                <div style={{ marginLeft: '10px' }}>
                    {t('GeneralExpenses')}
                </div>
            </div>
        );
    };

    const footerGroup = useMemo(() => (
        columns &&
        <ColumnGroup>
            <Row>
                <Column style={{ textAlign: 'right' }} footer={t("Total")} />
                {columns.map((col, index) => (
                    <Column
                        style={{ direction: 'ltr', textAlign: 'right' }}
                        key={col.field}
                        footer={<div >{footerTemplate(col)}</div>}
                    />
                ))}
                {isMonthly && (
                    <Column
                        style={{ direction: 'ltr', textAlign: 'right' }}
                        key={"total"}
                        footer={<div>{footerTemplate("total")}</div>}
                    />
                )}
            </Row>
            {specialNode && specialNode.data && (
                <Row>
                    <Column style={{ textAlign: 'right' }} footer={<div >{<FooterToggleTemplate2 />}</div>} />
                    {columns.map(col => (
                        <Column
                            key={col.field}
                            style={{ direction: 'ltr', textAlign: 'right' }}
                            footer={<div >{footerTemplate1(specialNode.data[col.field])}</div>}
                        />
                    ))}
                </Row>
            )}
            {specialNode && isExpandedToggle && specialNode.children.map(child => (
                <Row key={child.key}>
                    <Column
                        style={{ textAlign: 'right' }}
                        footer={<div onClick={() => handleSelect(child.data.Description, true)}>{child.data.Description}</div>}
                    />
                    {columns.map(col => (
                        <Column
                            key={`${child.key}-${col.field}`}
                            style={{ direction: 'ltr', textAlign: 'right' }}
                            footer={<div >{footerTemplate1(child.data[col.field])}</div>}
                        />
                    ))}
                </Row>
            ))}
        </ColumnGroup>
    ), [columns, footerTotals, specialNode, isExpandedToggle]);





    const generateMonthColumns = (startDate, endDate) => {

        const start = new Date(Date.UTC(startDate.getFullYear(), startDate.getMonth(), 10));
        const end = new Date(Date.UTC(endDate.getFullYear(), endDate.getMonth(), 10));
        const columns = [];

        for (let date = start; date <= end; date.setMonth(date.getMonth() + 1)) {
            const month = date.toLocaleString('default', { month: '2-digit' });
            const year = date.getFullYear();
            columns.push({ field: `${month}/${year}`, header: `${month}/${year}` });
        }

        // This ensures the total field is the last column
        // let totalField = `${startDate.toLocaleDateString('en-GB')} - ${endDate.toLocaleDateString('en-GB')}`;
        // columns.unshift({ field: totalField, header: totalField }); // Push to the front for RTL layout
        setTotalColumns(columns.length);
        return columns;
    };


    const refreshData = async () => {
        if (isMonthly) {
            await fetchProfitAndLossDetails(startDate, endDate);
        }
        else {
            await fetchProfitAndLossDetails(startYearDate, endYearDate);
        }
        
        // Refresh enums in HamburgerMenu to update TransactionSearchResultModal
        if (refreshEnumsCallback) {
            refreshEnumsCallback();
        }
    }

    const askPercentages = async (t) => {
        const res = await Swal.fire({
            title: t('IncludePercentagesTitle'),
            text: t('IncludePercentagesText'),
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: t('Yes'),
            cancelButtonText: t('No'),
            reverseButtons: true,
        });

        return res.isConfirmed;
    };

    const askAddSignatureForDownload = async () => {
        const result = await Swal.fire({
            title: t('AddSignatureTitle') || 'Add Signature?',
            text: t('AddSignatureQuestionDownload') || 'Do you want to add a digital signature and date to this document before downloading?',
            icon: 'question',
            showCancelButton: true,
            showCloseButton: true,
            confirmButtonColor: '#667eea',
            cancelButtonColor: '#6c757d',
            confirmButtonText: t('YesAddSignature') || 'Yes, Add Signature',
            cancelButtonText: t('NoDownloadWithout') || 'No, Download Without Signature',
            reverseButtons: true,
            allowOutsideClick: true,
            allowEscapeKey: true,
            didOpen: () => {
                const closeButton = document.querySelector('.swal2-close');
                if (closeButton) {
                    closeButton.style.setProperty('right', 'auto', 'important');
                    closeButton.style.setProperty('left', '10px', 'important');
                }
            }
        });
        return result;
    };

    const fetchProfitAndLossReportPdf = async ({
        withPct,
        showDetailedMonthlyBreakdown,
        selectedMonths,
        returnBlob = false,
    }) => {
        const segmentationFilter = buildSegmentationFilter();
        const options = { returnBlob, showItemsWithoutSortCodeGroup };

            const onlyProcessed = !showUnprocessed;
        if (isMonthly) {
            const bounds = showDetailedMonthlyBreakdown
                ? selectedMonthsToDateBounds(selectedMonths)
                : null;

            return ProfitAndLossService.ProfitAndLossDetailsMonthlyReport(
                client.caseId,
                client.accountantId,
                bounds?.startDate ?? startDate,
                bounds?.endDate ?? endDate,
                token,
                withPct,
                showNonParticipantItems,
                segmentationFilter,
                filterByDocumentDate,
                showDetailedMonthlyBreakdown,
                selectedMonths,
                onlyProcessed,
                options,
            );
        }

        const yearlyStartDate = dayjs.utc(startYearDate).startOf('year').toDate();
        const yearlyEndDate = dayjs.utc(endYearDate).endOf('year').toDate();

        return ProfitAndLossService.ProfitAndLossDetailsYearlyReport(
            client.caseId,
            client.accountantId,
            yearlyStartDate,
            yearlyEndDate,
            token,
            withPct,
            showNonParticipantItems,
            segmentationFilter,
            filterByDocumentDate,
            onlyProcessed,
            options,
        );
    };

    const runProfitAndLossPdfDownload = async (downloadOptions) => {
        setLoading(true);
        try {
            await fetchProfitAndLossReportPdf({ ...downloadOptions, returnBlob: false });
            toast.success(t('reportDownloadSuccess'));
        } catch (err) {
            console.error(err);
            toast.error(t('reportDownloadFailure'));
        } finally {
            setLoading(false);
        }
    };

    const handleDownloadModalConfirm = async ({
        withPct,
        showDetailedMonthlyBreakdown,
        selectedMonths,
    }) => {
        setDownloadModalOpen(false);

        if (loading) return;

        const downloadOptions = {
            withPct,
            showDetailedMonthlyBreakdown,
            selectedMonths,
        };

        const signatureResult = await askAddSignatureForDownload();

        if (signatureResult.isConfirmed) {
            setPendingDownloadOptions(downloadOptions);
            setShowSignatureModal(true);
            return;
        }

        if (signatureResult.dismiss === Swal.DismissReason.cancel) {
            await runProfitAndLossPdfDownload(downloadOptions);
        }
        // Close / ESC / outside click — do nothing
    };

    const handleDownloadWithSignature = async (signatureDataUrl) => {
        if (!pendingDownloadOptions || !client?.caseId || !token) {
            setShowSignatureModal(false);
            setPendingDownloadOptions(null);
            return;
        }

        setShowSignatureModal(false);
        setLoading(true);
        const loadingToast = toast.info(t('GeneratingSignedPDF') || 'Generating signed PDF...', {
            autoClose: false,
            closeButton: false,
        });

        try {
            const { blob, fileName } = await fetchProfitAndLossReportPdf({
                ...pendingDownloadOptions,
                returnBlob: true,
            });

            const signedBlob = await mergeReportPdfWithSignature({
                reportPdfBlob: blob,
                signatureDataUrl,
                caseId: client.caseId,
                token,
                convertHtmlToPdf: ReportsService.convertHtmlToPdf,
            });

            triggerBlobDownload(signedBlob, fileName);
            toast.dismiss(loadingToast);
            toast.success(t('reportDownloadSuccess'));
        } catch (err) {
            console.error(err);
            toast.dismiss(loadingToast);
            toast.error(t('reportDownloadFailure'));
        } finally {
            setPendingDownloadOptions(null);
            setLoading(false);
        }
    };

    const downloadReport = async () => {
        if (loading) return;
        setDownloadModalOpen(true);
    };

    const downloadExcelReport = async () => {
        const withPct = await askPercentages(t);

        if (withPct === null) return;

        setLoading(true);
        try {
            const segmentationFilter = buildSegmentationFilter();
            const onlyProcessed = !showUnprocessed;
            if (isMonthly) {
                const selectedMonths = buildSelectedMonthsFromDateRange(startDate, endDate);
                const bounds = selectedMonthsToDateBounds(selectedMonths);

                await ProfitAndLossService.ProfitAndLossExcelReport(
                    client.caseId,
                    client.accountantId,
                    bounds?.startDate ?? startDate,
                    bounds?.endDate ?? endDate,
                    token,
                    withPct,
                    true,
                    showNonParticipantItems,
                    segmentationFilter,
                    filterByDocumentDate,
                    onlyProcessed,
                    showItemsWithoutSortCodeGroup,
                    true,
                    selectedMonths,
                );
            } else {
                const yearlyStartDate = dayjs.utc(startYearDate).startOf('year').toDate();
                const yearlyEndDate = dayjs.utc(endYearDate).endOf('year').toDate();

                await ProfitAndLossService.ProfitAndLossExcelReport(
                    client.caseId,
                    client.accountantId,
                    yearlyStartDate,
                    yearlyEndDate,
                    token,
                    withPct,
                    false,
                    showNonParticipantItems,
                    segmentationFilter,
                    filterByDocumentDate,
                    onlyProcessed,
                    showItemsWithoutSortCodeGroup
                );
            }
            toast.success(t('reportDownloadSuccess'));
        } catch (err) {
            console.error(err);
            toast.error(t('reportDownloadFailure'));
        } finally {
            setLoading(false);
        }
    };

    const openHtmlPreview = async () => {
        // Only works with yearly reports
        if (isMonthly) {
            toast.error(t('MatchingProfitAndLossReportOnlyYearly'));
            return;
        }
        if (!validateYearlyDateRangeForHtml()) return;

        setLoading(true);
        try {
            const html = await loadYearlyProfitAndLossHtml(true);
            setHtmlPreviewContent(html);
            setIsHtmlPreviewModalOpen(true);
        } catch (err) {
            console.error(err);
            toast.error(t('ErrorFetchingProfitLossDetails'));
        } finally {
            setLoading(false);
        }
    };

    const validateYearlyDateRangeForHtml = () => {
        if (startYearDate && endYearDate) {
            const startYearDateObj = dayjs.utc(startYearDate);
            const endYearDateObj = dayjs.utc(endYearDate);
            const StartYear = startYearDateObj.year();
            const EndYear = endYearDateObj.year();
            if (StartYear !== EndYear) {
                toast.info(t('YearAdjustedToMatch') || `End date adjusted to the same year (${StartYear})`);
                return false;
            }
        }
        return true;
    };

    const loadYearlyProfitAndLossHtml = async (showPct) => {
        const yearlyStartDate = dayjs.utc(startYearDate).startOf('year').toDate();
        const yearlyEndDate = dayjs.utc(endYearDate).endOf('year').toDate();

        return ProfitAndLossService.ProfitAndLossDetailsYearlyHtml(
            client.caseId,
            client.accountantId,
            yearlyStartDate,
            yearlyEndDate,
            token,
            showPct,
            showNonParticipantItems,
            filterByDocumentDate,
            !showUnprocessed,
            showItemsWithoutSortCodeGroup,
        );
    };

    const loadMonthlyProfitAndLossHtml = async (showPct) => {
        const segmentationFilter = buildSegmentationFilter();
        const selectedMonths = buildSelectedMonthsFromDateRange(startDate, endDate);
        const bounds = selectedMonthsToDateBounds(selectedMonths);

        return ProfitAndLossService.ProfitAndLossDetailsMonthlyHtml(
            client.caseId,
            client.accountantId,
            bounds?.startDate ?? startDate,
            bounds?.endDate ?? endDate,
            token,
            showPct,
            showNonParticipantItems,
            segmentationFilter,
            filterByDocumentDate,
            true,
            selectedMonths,
            !showUnprocessed,
            showItemsWithoutSortCodeGroup,
        );
    };

    const loadEditableProfitAndLossHtml = async (showPct) => {
        if (isMonthly) {
            return loadMonthlyProfitAndLossHtml(showPct);
        }
        return loadYearlyProfitAndLossHtml(showPct);
    };

    const handleOpenEditableProfitAndLossReport = async () => {
        if (!isMonthly && !validateYearlyDateRangeForHtml()) return;

        setEditableShowPercentageColumn(false);
        setOpenEditableProfitAndLossModal(true);
        editableInitialLoadDoneRef.current = false;
        setLoading(true);
        try {
            const html = await loadEditableProfitAndLossHtml(false);
            setEditableProfitAndLossHtmlContent(html);
            editableInitialLoadDoneRef.current = true;
        } catch (err) {
            console.error(err);
            toast.error(t('ErrorFetchingProfitLossDetails'));
            setOpenEditableProfitAndLossModal(false);
        } finally {
            setLoading(false);
        }
    };

    const handleCloseEditableProfitAndLossReport = () => {
        setOpenEditableProfitAndLossModal(false);
        setEditableProfitAndLossHtmlContent('');
        setEditableShowPercentageColumn(false);
        editableInitialLoadDoneRef.current = false;
    };

    useEffect(() => {
        if (!openEditableProfitAndLossModal || !editableInitialLoadDoneRef.current) return undefined;

        let cancelled = false;
        const refetchEditableHtml = async () => {
            setLoading(true);
            try {
                const html = await loadEditableProfitAndLossHtml(editableShowPercentageColumn);
                if (!cancelled) {
                    setEditableProfitAndLossHtmlContent(html);
                }
            } catch (err) {
                console.error(err);
                if (!cancelled) {
                    toast.error(t('ErrorFetchingProfitLossDetails'));
                }
            } finally {
                if (!cancelled) {
                    setLoading(false);
                }
            }
        };

        refetchEditableHtml();
        return () => {
            cancelled = true;
        };
    }, [editableShowPercentageColumn, openEditableProfitAndLossModal, isMonthly]);
    const paginatorLeft = <Button type="button" icon="pi pi-refresh" text onClick={refreshData} />;
    const paginatorRight = <Button type="button" icon="pi pi-download" text onClick={downloadReport} />;

    const valueTemplate = (node, column) => {
        // Access the value from the node data based on the column field
        let value = node.data[column.field];

        // Determine the color based on the value: green if positive, red if zero or negative
        let color = parseInt(value, 10) >= 0 ? 'green' : 'red';

        // Return a span element with the styled value
        return (
            <span style={{ color: color, fontWeight: 'bold' }}>
                {value !== null ? parseFloat(value).toFixed(2).toLocaleString() : '0.00'}
            </span>
        );
    }
    const valueTotalTemplate = (node, column) => {
        // Access the value from the node data based on the column field
        let value = node.data[column];

        // Determine the color based on the value: green if positive, red if zero or negative
        let color = parseInt(value, 10) >= 0 ? 'green' : 'red';

        // Return a span element with the styled value
        return (
            <span style={{ color: color, fontWeight: 'bold' }}>
                {value !== null ? parseFloat(value).toFixed(2).toLocaleString() : '0.00'}
            </span>
        );
    }
    const keyTemplate = (node, column) => {
        // Access the value from the node data based on the column field
        let value = node.data[column];

        // Determine the color based on the value: green if positive, red if zero or negative
        let color = 'black';

        // Return a span element with the styled value
        return <span style={{ color: color, fontWeight: 'bold' }}>{value}</span>;
    }

    const rowClassName = (node) => {
        return !node.children && node.key && /^\d+$/.test(node.key) && 'p-highlight';
    }
    const footer = (
        <div className="flex justify-content-end">
            <Button icon="pi pi-refresh" label="Reload" severity="warning" />
        </div>
    );

    const handleExpandRow = (key) => {
        setExpandedRows((prev) => ({
            ...prev,
            [key]: !prev[key]
        }));
    };

    const handleDateBasisChange = (byDocumentDate) => {
        if (byDocumentDate === filterByDocumentDate) return;
        setFilterByDocumentDate(byDocumentDate);
        localStorage.setItem('profitAndLossFilterByDocumentDate', byDocumentDate);
    };

    // Only accountants / sub-accountants may edit sort codes (SortCodes/Update is accountant-only).
    const canEditSortCodes = useMemo(() => {
        const userType = String(UserService.getCurrentUserType() ?? '');
        return userType === '2' || userType === '8';
    }, []);

    const sortCodeGroupSelectOptions = useMemo(
        () =>
            (sortCodesGroupOptions ?? [])
                .filter((option) => option?.sortCodeGroup)
                .map((option) => ({
                    value: option.sortCodeGroup,
                    label: option.sortCodeGroup,
                })),
        [sortCodesGroupOptions],
    );

    const handleAssignSortCodeGroupRequest = (rowData) => {
        const sortCodeId = rowData?.SortCodeId;
        if (!sortCodeId) return;

        const sortCode = (sortCodesOptions ?? []).find(
            (option) => String(option.sortCodeId) === String(sortCodeId),
        );

        if (!sortCode) {
            toast.error(t('SortCodeNotFound'));
            return;
        }

        setAssignGroupSortCode(sortCode);
        setAssignGroupValue(
            sortCodeGroupSelectOptions.find((option) => option.value === sortCode.sortCodeGroup) || null,
        );
        setAssignParticipates(Boolean(sortCode.participatesInProfitAndLoss));
    };

    const handleCloseAssignSortCodeGroup = () => {
        setAssignGroupSortCode(null);
        setAssignGroupValue(null);
        setAssignParticipates(true);
    };

    // A sort code that participates in the report must belong to a group, otherwise it
    // has no place to be listed under.
    const canSaveSortCodeEdit =
        Boolean(assignGroupSortCode) && (!assignParticipates || Boolean(assignGroupValue?.value));

    const handleSaveAssignSortCodeGroup = async () => {
        if (!canSaveSortCodeEdit) return;

        setLoading(true);
        try {
            const response = await EnumsService.UpdateSortCode(
                client.accountantId,
                assignGroupSortCode.sortCodeId,
                assignGroupSortCode.sortCodeId,
                assignGroupSortCode.sortCodeName,
                assignGroupValue?.value ?? null,
                assignGroupSortCode.creditAccount,
                assignGroupSortCode.debitAccount,
                assignGroupSortCode.sortCodeVatType,
                assignGroupSortCode.vat,
                assignParticipates,
                assignGroupSortCode.pcnTransactionType,
                assignGroupSortCode.code6111Id ?? null,
                false,
                assignGroupSortCode.inventoryType ?? 0,
                token,
            );

            if (!response.ok) {
                toast.error(`${t('FailedToUpdateSortCode')}: ${await response.text()}`);
                return;
            }

            toast.success(t('SortCodeUpdated'));
            handleCloseAssignSortCodeGroup();
            await fetchEnums(token, user);
            await refreshData();
        } catch (err) {
            console.error(err);
            toast.error(t('FailedToUpdateSortCode'));
        } finally {
            setLoading(false);
        }
    };

    const dateBasisToggleTabs = (
        <div
            style={{
                display: 'flex',
                gap: '2px',
                height: '26px',
                padding: '1px',
                borderRadius: '4px',
                background: '#F8F9FA',
                border: '1px solid #E9ECEF',
                alignSelf: 'center',
            }}
        >
            <div
                onClick={() => handleDateBasisChange(true)}
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '2px 8px',
                    borderRadius: '3px',
                    cursor: 'pointer',
                    backgroundColor: filterByDocumentDate ? '#304FFF' : 'transparent',
                    color: filterByDocumentDate ? '#FFFFFF' : '#6C757D',
                    fontWeight: filterByDocumentDate ? '600' : '500',
                    fontSize: '12px',
                    whiteSpace: 'nowrap',
                    transition: 'all 0.2s ease',
                }}
            >
                {t('DocumentDate')}
            </div>
            <div
                onClick={() => handleDateBasisChange(false)}
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '2px 8px',
                    borderRadius: '3px',
                    cursor: 'pointer',
                    backgroundColor: !filterByDocumentDate ? '#304FFF' : 'transparent',
                    color: !filterByDocumentDate ? '#FFFFFF' : '#6C757D',
                    fontWeight: !filterByDocumentDate ? '600' : '500',
                    fontSize: '12px',
                    whiteSpace: 'nowrap',
                    transition: 'all 0.2s ease',
                }}
            >
                {t('RegistrationMonth')}
            </div>
        </div>
    );

    const rangeToggleTabs = (
        <div
            style={{
                display: 'flex',
                gap: '2px',
                height: '26px',
                padding: '1px',
                borderRadius: '4px',
                background: '#F8F9FA',
                border: '1px solid #E9ECEF',
                alignSelf: 'center',
            }}
        >
            <div
                onClick={() => {
                    if (isMonthly) handleRangeChange(false);
                }}
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '2px 6px',
                    borderRadius: '3px',
                    cursor: 'pointer',
                    backgroundColor: !isMonthly ? '#304FFF' : 'transparent',
                    color: !isMonthly ? '#FFFFFF' : '#6C757D',
                    fontWeight: !isMonthly ? '600' : '500',
                    fontSize: '12px',
                    width: '36px',
                    transition: 'all 0.2s ease',
                }}
            >
                {t('Yearly')}
            </div>
            <div
                onClick={() => {
                    if (!isMonthly) handleRangeChange(true);
                }}
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '2px 6px',
                    borderRadius: '3px',
                    cursor: 'pointer',
                    backgroundColor: isMonthly ? '#304FFF' : 'transparent',
                    color: isMonthly ? '#FFFFFF' : '#6C757D',
                    fontWeight: isMonthly ? '600' : '500',
                    fontSize: '12px',
                    width: '36px',
                    transition: 'all 0.2s ease',
                }}
            >
                {t('Monthly')}
            </div>
        </div>
    );



    const headerStyle = {
        backgroundColor: '#f7f7f7',
        color: 'black',
        fontWeight: 'bold',
        direction: 'ltr'
    }

    const filteredAndSortedNodes = useMemo(() => {
        const q = searchQuery.trim().toLowerCase();
        if (!q) return nodes;                       // nothing to filter

        const matchString = (s) => s?.toLowerCase().includes(q);
        const matchNumber = (n) =>
            n != null && !isNaN(n) && n.toString().toLowerCase().includes(q);

        return nodes.filter((parent) => {
            /* 1 . parent title */
            if (matchString(parent.data.Description)) return true;

            /* 2 . any number on the parent row */
            if (columns.some((c) => matchNumber(parent.data[c.field]))) return true;

            /* 3 . any child title / numbers */
            return (parent.children ?? []).some((ch) => {
                if (matchString(ch.data.Description)) return true;
                return columns.some((c) => matchNumber(ch.data[c.field]));
            });
        });
    }, [nodes, columns, searchQuery]);

    const buttonData = [
        {
            label: 'Downloads',
            isDropdown: true,
            iconColor: 'green',
            dropdownItems: [
                {
                    label: 'DownloadProfitAndLossReport',
                    onClick: () => downloadReport(),
                    icon: () => <DownloadIcon fontSize="small" />,
                },
                {
                    label: 'DownloadProfitAndLossExcel',
                    onClick: () => downloadExcelReport(),
                    icon: () => <DownloadIcon fontSize="small" />,
                },
            ],
        },
        {
            label: 'Actions',
            isDropdown: true,
            iconColor: 'green',
            dropdownItems: [
                {
                    label: 'EditableProfitAndLossReport',
                    onClick: () => handleOpenEditableProfitAndLossReport(),
                    icon: () => <DescriptionIcon fontSize="small" />,
                },
                {
                    label: 'UpdateDepreciationJournalEntries',
                    onClick: () => setIsJournalEntrySelectionModalOpen(true),
                },
                ...(!isMonthly ? [{
                    label: 'MatchingProfitAndLossReport',
                    onClick: () => openHtmlPreview(),
                }] : []),
            ],
        },
    ];

    return (
        <>
            <>
                <NavigationButton
                    t={t}
                    direction={direction}
                    data={buttonData}
                />
                <div className={`searchFilter-bar__container document-toolbar-row ${direction}`}>
                    <Box className="document-filter-row" dir={direction}>
                        <TextField
                            size="small"
                            dir={direction}
                            placeholder={t('Search')}
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            className="document-search-bar"
                            variant="standard"
                            InputProps={{
                                disableUnderline: true,
                                className: `custom-input-box-sizing ${direction === 'ltr' ? 'ltr-input' : 'rtl-input'}`,
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon className="document-search-icon" />
                                    </InputAdornment>
                                ),
                            }}
                        />

                        <Box className="document-data-view">
                            <ToggleButtonGroup
                                value={isMonthly ? 'monthly' : 'yearly'}
                                exclusive
                                onChange={(event, newValue) => {
                                    if (newValue !== null) {
                                        handleRangeChange(newValue === 'monthly');
                                    }
                                }}
                                size="small"
                            >
                                <ToggleButton value="yearly" aria-label="yearly">
                                    {t('Yearly')}
                                </ToggleButton>
                                <ToggleButton value="monthly" aria-label="monthly">
                                    {t('Monthly')}
                                </ToggleButton>
                            </ToggleButtonGroup>
                        </Box>

                        {isMonthly ? (
                            <div className={headerStyles.dateSelectRange}>
                                <div className={headerStyles.dateSelect}>
                                    <FilterMonthYearPicker
                                        year={startDate}
                                        month={startDate}
                                        onYearChange={(newYear) => handleStartDateChangeNew(newYear, 'year')}
                                        onMonthChange={(newMonth) => handleStartDateChangeNew(newMonth, 'month')}
                                        labelYear={t('StartYear')}
                                        labelMonth={t('StartMonth')}
                                        direction={direction}
                                    />
                                </div>
                                <div className={headerStyles.rangeDivider} />
                                <div className={headerStyles.dateSelect}>
                                    <FilterMonthYearPicker
                                        year={endDate}
                                        month={endDate}
                                        onYearChange={(newYear) => handleEndDateChangeNew(newYear, 'year')}
                                        onMonthChange={(newMonth) => handleEndDateChangeNew(newMonth, 'month')}
                                        labelYear={t('EndYear')}
                                        labelMonth={t('EndMonth')}
                                        direction={direction}
                                    />
                                </div>
                            </div>
                        ) : (
                            <div className={`${headerStyles.dateSelectRange} ${headerStyles.dateSelectRangeCompact}`}>
                                <div className={headerStyles.dateSelectYear}>
                                    <FilterMonthYearPicker
                                        year={startYearDate}
                                        onYearChange={(date) => handleStartYearDate(date)}
                                        labelYear={t('StartDate')}
                                        direction={direction}
                                        yearOnly
                                    />
                                </div>
                                <div className={headerStyles.rangeDivider} />
                                <div className={headerStyles.dateSelectYear}>
                                    <FilterMonthYearPicker
                                        year={endYearDate}
                                        onYearChange={(date) => handleEndYearDate(date)}
                                        labelYear={t('EndDate')}
                                        direction={direction}
                                        yearOnly
                                    />
                                </div>
                            </div>
                        )}

                        <Box className="document-data-view">
                            <span className="document-data-view__label">{t('DataView')}</span>
                            <ToggleButtonGroup
                                value={filterByDocumentDate ? 'document' : 'registration'}
                                exclusive
                                onChange={(event, newValue) => {
                                    if (newValue !== null) {
                                        handleDateBasisChange(newValue === 'document');
                                    }
                                }}
                                size="small"
                            >
                                <ToggleButton value="document" aria-label="document date">
                                    {t('DocumentDate')}
                                </ToggleButton>
                                <ToggleButton value="registration" aria-label="registration month">
                                    {t('RegistrationMonth')}
                                </ToggleButton>
                            </ToggleButtonGroup>
                        </Box>
                    </Box>

                    <Box className="document-mode-toggles">
                        <Box className={`document-mode-toggle${showNonParticipantItems ? ' is-checked' : ''}`}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={showNonParticipantItems}
                                        onChange={(e) => {
                                            const newValue = e.target.checked;
                                            setShowNonParticipantItems(newValue);
                                            localStorage.setItem('showNonParticipantItems', newValue);
                                        }}
                                        inputProps={{ 'aria-label': t('ShowNonParticipantItems') }}
                                        size="small"
                                    />
                                }
                                label={t('ShowNonParticipantItems')}
                            />
                        </Box>
                        <Box className={`document-mode-toggle${showUnprocessed ? ' is-checked' : ''}`}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={showUnprocessed}
                                        onChange={(e) => {
                                            const newValue = e.target.checked;
                                            setShowUnprocessed(newValue);
                                            localStorage.setItem('profitAndLossShowUnprocessed', newValue);
                                        }}
                                        inputProps={{ 'aria-label': t('ShowUnprocessedDocuments') }}
                                        size="small"
                                    />
                                }
                                label={t('ShowUnprocessedDocuments')}
                            />
                        </Box>
                        <Box className={`document-mode-toggle${showItemsWithoutSortCodeGroup ? ' is-checked' : ''}`}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={showItemsWithoutSortCodeGroup}
                                        onChange={(e) => {
                                            const newValue = e.target.checked;
                                            setShowItemsWithoutSortCodeGroup(newValue);
                                            localStorage.setItem('profitAndLossShowItemsWithoutSortCodeGroup', newValue);
                                        }}
                                        inputProps={{ 'aria-label': t('ShowItemsWithoutSortCodeGroup') }}
                                        size="small"
                                    />
                                }
                                label={t('ShowItemsWithoutSortCodeGroup')}
                            />
                        </Box>
                    </Box>
                </div>

                {client?.managesProject && (
                    <div
                        className={documentGridStyles.toolbar}
                        dir={direction}
                        style={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            alignItems: 'center',
                            gap: '8px',
                            marginBottom: '8px',
                            justifyContent: direction === 'rtl' ? 'flex-start' : 'flex-end',
                        }}
                    >
                        <label className={`${documentGridStyles.byProjects}${byProjectsFilterActive ? ` ${documentGridStyles.checked}` : ''}`}>
                            <Checkbox
                                checked={!!byProjectsFilterActive}
                                onChange={(event) => handleByProjectsFilterToggle(event.target.checked)}
                                name="ByProjects"
                                size="small"
                                sx={{
                                    padding: '2px',
                                    color: '#c5c8e0',
                                    '&.Mui-checked': { color: '#304fff' },
                                }}
                            />
                            <span>{t('ByProjects')}</span>
                        </label>
                        {byProjectsFilterActive && (
                            <div className={documentGridStyles.projectPickers} dir={direction}>
                                {loadingSegmentations && <CircularProgress size={22} />}
                                <div className={documentGridStyles.projectField}>
                                    <Autocomplete
                                        size="small"
                                        loading={loadingSegmentations}
                                        options={segmentationProjects}
                                        getOptionLabel={(opt) => opt?.label ?? ''}
                                        isOptionEqualToValue={(a, b) => String(a?.id) === String(b?.id)}
                                        value={selectedFromSegmentation}
                                        onChange={handleFromSegmentationChange}
                                        PopperComponent={(popperProps) => (
                                            <StyledProjectsPopper {...popperProps} dir={direction} />
                                        )}
                                        ListboxProps={{ dir: direction }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                placeholder={t('FromProject')}
                                                size="small"
                                                variant="standard"
                                                dir={direction}
                                                InputProps={{
                                                    ...params.InputProps,
                                                    disableUnderline: true,
                                                }}
                                            />
                                        )}
                                        clearOnBlur={false}
                                        dir={direction}
                                    />
                                </div>
                                <div className={documentGridStyles.projectField}>
                                    <Autocomplete
                                        size="small"
                                        loading={loadingSegmentations}
                                        options={segmentationProjects}
                                        getOptionLabel={(opt) => opt?.label ?? ''}
                                        isOptionEqualToValue={(a, b) => String(a?.id) === String(b?.id)}
                                        value={selectedToSegmentation}
                                        onChange={handleToSegmentationChange}
                                        PopperComponent={(popperProps) => (
                                            <StyledProjectsPopper {...popperProps} dir={direction} />
                                        )}
                                        ListboxProps={{ dir: direction }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                placeholder={t('ToProject')}
                                                size="small"
                                                variant="standard"
                                                dir={direction}
                                                InputProps={{
                                                    ...params.InputProps,
                                                    disableUnderline: true,
                                                }}
                                            />
                                        )}
                                        clearOnBlur={false}
                                        dir={direction}
                                    />
                                </div>
                            </div>
                        )}
                    </div>
                )}

                <ProfitAndLossReportTable
                    rows={filteredAndSortedNodes}
                    columns={columns}
                    isMonthly={isMonthly}
                    startDate={startDate}
                    endDate={endDate}
                    footerTotals={footerTotals}
                    specialNode={specialNode}
                    handleSelect={handleSelect}
                    onAssignSortCodeGroup={canEditSortCodes ? handleAssignSortCodeGroupRequest : undefined}
                />

            </>

            {/* Journal Entry Selection Modal */}
            <DepreciationJournalEntriesModal
                open={isJournalEntrySelectionModalOpen}
                onClose={() => setIsJournalEntrySelectionModalOpen(false)}
                onConfirm={() => setIsJournalEntrySelectionModalOpen(false)}
                client={client}
                token={token}
                selectedEntries={[]}
                title="UpdateDepreciationJournalEntries"
                direction={direction}
                debitAccountOptions={[]}
                sortCodeIdOptions={[]}
                onJournalEntryCreated={refreshData}
            />

            {/* HTML Preview Modal */}
            <ProfitAndLossHtmlPreview
                open={isHtmlPreviewModalOpen}
                htmlContent={htmlPreviewContent}
                onCancel={() => setIsHtmlPreviewModalOpen(false)}
                onOk={() => setIsHtmlPreviewModalOpen(false)}
                t={t}
                withCancel={true}
                title="MatchingProfitAndLossReport"
                client={client}
                token={token}
                year={startYearDate ? dayjs.utc(startYearDate).year() : dayjs.utc().year()}
                accountantId={client?.accountantId || ''}
            />

            {openEditableProfitAndLossModal && client && (
                <EditableProfitAndLossHtmlPreview
                    open={openEditableProfitAndLossModal}
                    htmlContent={editableProfitAndLossHtmlContent}
                    onCancel={handleCloseEditableProfitAndLossReport}
                    t={t}
                    title="EditableProfitAndLossReport"
                    client={client}
                    token={token}
                    isMonthly={isMonthly}
                    direction={direction}
                    showPercentageColumn={editableShowPercentageColumn}
                    setShowPercentageColumn={setEditableShowPercentageColumn}
                    reportData={{ clientName: client?.name || 'Client' }}
                    source={EDITABLE_SOURCE_PL_REPORT}
                />
            )}

            <ProfitAndLossDownloadModal
                open={downloadModalOpen}
                onClose={() => setDownloadModalOpen(false)}
                onConfirm={handleDownloadModalConfirm}
                isMonthly={isMonthly}
                startDate={startDate}
                endDate={endDate}
                direction={direction}
                t={t}
            />

            <Dialog
                open={Boolean(assignGroupSortCode)}
                onClose={handleCloseAssignSortCodeGroup}
                fullWidth
                maxWidth="xs"
                dir={direction}
            >
                <DialogTitle sx={{ textAlign: direction === 'rtl' ? 'right' : 'left' }}>
                    {t('EditSortCodeProfitAndLossMapping')}
                </DialogTitle>
                <DialogContent>
                    <div
                        style={{
                            marginBottom: '12px',
                            fontSize: '0.875rem',
                            color: '#666666',
                            textAlign: direction === 'rtl' ? 'right' : 'left',
                        }}
                    >
                        {assignGroupSortCode
                            ? `${assignGroupSortCode.sortCodeId} - ${assignGroupSortCode.sortCodeName}`
                            : ''}
                    </div>
                    <Autocomplete
                        options={sortCodeGroupSelectOptions}
                        getOptionLabel={(option) => option?.label ?? ''}
                        isOptionEqualToValue={(a, b) => a?.value === b?.value}
                        value={assignGroupValue}
                        onChange={(_, newValue) => setAssignGroupValue(newValue)}
                        PopperComponent={StyledProjectsPopper}
                        componentsProps={{
                            // Keep the list above the dialog surface (RTL-safe placement).
                            popper: {
                                placement: direction === 'rtl' ? 'bottom-end' : 'bottom-start',
                                style: { zIndex: 14000 },
                            },
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                placeholder={t('SelectSortCodeGroupName')}
                                size="small"
                                dir={direction}
                            />
                        )}
                    />

                    <FormControlLabel
                        sx={{
                            marginTop: '12px',
                            marginLeft: 0,
                            marginRight: 0,
                            justifyContent: direction === 'rtl' ? 'flex-end' : 'flex-start',
                        }}
                        control={
                            <Switch
                                checked={assignParticipates}
                                onChange={(event) => setAssignParticipates(event.target.checked)}
                                disabled={assignGroupSortCode?.isEditable === false}
                            />
                        }
                        label={
                            <span style={{ fontSize: '14px', color: '#304FFF', fontWeight: 500 }}>
                                {t('participatesInProfitAndLoss')}
                            </span>
                        }
                    />

                    {assignParticipates && !assignGroupValue?.value && (
                        <div
                            style={{
                                fontSize: '0.8125rem',
                                color: '#d32f2f',
                                textAlign: direction === 'rtl' ? 'right' : 'left',
                            }}
                        >
                            {t('SortCodeGroupRequiredWhenParticipating')}
                        </div>
                    )}

                    {assignGroupSortCode?.isEditable === false && (
                        <div
                            style={{
                                marginTop: '8px',
                                fontSize: '0.8125rem',
                                color: '#666666',
                                textAlign: direction === 'rtl' ? 'right' : 'left',
                            }}
                        >
                            {t('LockedSortCodeOnlyGroupEditable')}
                        </div>
                    )}
                </DialogContent>
                <DialogActions>
                    <MuiButton onClick={handleCloseAssignSortCodeGroup} sx={{ color: '#666666' }}>
                        {t('Cancel')}
                    </MuiButton>
                    <MuiButton
                        onClick={handleSaveAssignSortCodeGroup}
                        disabled={!canSaveSortCodeEdit}
                        variant="contained"
                        sx={{ background: '#304FFF' }}
                    >
                        {t('Save')}
                    </MuiButton>
                </DialogActions>
            </Dialog>

            <SignatureModal
                open={showSignatureModal}
                handleClose={() => {
                    setShowSignatureModal(false);
                    setPendingDownloadOptions(null);
                }}
                onSendWithSignature={handleDownloadWithSignature}
                confirmLabel={t('SignAndDownload') || 'Sign & Download'}
                reportPreview={`${client?.name || ''} - ${t('ProfitAndLossReport') || 'Profit and Loss Report'}`}
            />

            <ToastContainer />
            {loading && (
                <div className="loader-container">
                    <PuffLoader
                        size={100}        // Larger size for better visibility
                        loading={loading}
                    />
                </div>
            )}

        </>
    );
}


export default ProfitAndLossReport;
